<span class="icon" [ngClass]="iconClasses" [innerHTML]="iconElement$ | async" [style]="{display, rotate: rotation}"> </span>
